import api from "./api";

/*
  Inventory Report Service
  Used ONLY for View Report button
*/

// const InventoryReportService = {

//   // ---------------- INVENTORY REPORT ----------------
//   getReport: async ({ companyId, projectId, storeId, itemId }) => {
//     try {
//       const res = await api.get(
//         "/inventoryReport/getSearch",
//         {
//           params: {
//             companyId,
//             projectId,
//             storeId,
//             itemId
//           }
//         }
//       );

//       // backend returns { status, data, message }
//       return res.data;
//     } catch (err) {
//       console.error("Inventory report error", err);
//       return { status: false, data: [] };
//     }
//   }

// };

// export default InventoryReportService;
const InventoryReportService = {

  getReport: async ({
    companyId,
    employeeId,
    roleId,
    projectId,
    storeId,
    itemId,
    itemCategoryId,
    page,
    limit
  }) => {
    try {
      const res = await api.get("/inventoryReport/getSearch", {
        params: {
          companyId,
          employeeId,
          roleId,
          projectId,
          storeId,
          itemId,
          itemCategoryId,
          page,
          limit
        }
      });

      return res.data; // { status, data, message }
    } catch (err) {
      console.error("Inventory report error", err);
      return { status: false, data: [] };
    }
  },

  getProjectsForInventoryReport: async ({
    companyId,
    employeeId,
    roleId
  }) => {
    try {
      const res = await api.get("/inventoryReport/inventory-projects", {
        params: {
          companyId,
          employeeId,
          roleId
        }
      });

      return res.data; // { status, result }
    } catch (err) {
      console.error("Inventory projects error", err);
      return { status: false, result: [] };
    }
  },

  getInventoryTransactionReport: async ({
    pageNumber,
    noofRows,
    companyId,
    employeeId,
    roleId,
    fromCompany,
    toCompany,
    fromProject,
    toProject,
    fromStore,
    toStore,
    itemCategory,
    itemName,
    fromDate,
    toDate
  }) => {
    try {
      const res = await api.get("/inventoryReport/transactions", {
        params: {
          pageNumber,
          noofRows,
          companyId,
          employeeId,
          roleId,
          fromCompany,
          toCompany,
          fromProject,
          toProject,
          fromStore,
          toStore,
          itemCategory,
          itemName,
          fromDate,
          toDate
        }
      });

      return res.data; // { status, result }
    } catch (err) {
      console.error("Inventory projects error", err);
      return { status: false, result: [] };
    }
  }


};

export default InventoryReportService;